import { useMutation } from '@apollo/client';
import {
  DeleteDashboardDocument,
  namedOperations,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';

import { useDeleteDashboardTRPC } from './useDeleteDashboardTRPC';

export const useDeleteDashboard = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  // GraphQL mutation
  const [deleteDashboardGraphQL, graphqlState] = useMutation(
    DeleteDashboardDocument,
    {
      refetchQueries: [namedOperations.Query.getDashboards],
    }
  );

  // tRPC mutation
  const trpcMutation = useDeleteDashboardTRPC();

  const deleteDashboard = async (variables: { Id: string }): Promise<void> => {
    if (trpcEnabled) {
      return trpcMutation.deleteDashboard(variables);
    }

    const result = await deleteDashboardGraphQL({
      variables: { Id: variables.Id },
    });

    if (!result.data) {
      throw new Error('Failed to delete dashboard');
    }
  };

  // Return appropriate state based on feature flag
  if (trpcEnabled) {
    return {
      deleteDashboard,
      loading: trpcMutation.loading,
      error: trpcMutation.error,
    };
  }

  return {
    deleteDashboard,
    loading: graphqlState.loading,
    error: graphqlState.error,
  };
};
